// 組織與場域（一級選單 /sites，舊網址 /settings/structure 轉址；SPEC #org-tree-ui 第 2 點、#vms-web-220，VMS UX 評審 2026-10-13 P0-4）：
// 一次一個組織 = 頁首範圍所在的組織（頁內不另放組織下拉，組織膠囊切換 = 切頁首範圍；「全部」時先問要管理哪個組織）。
// owner / org_admin / org.sites 管全樹；其他成員（可能是某個節點的 node_admin）照樣打 GET …/nodes，伺服器只回他的有效子樹，沒有就顯示「沒有可以管理的節點」。
// 場域詳細三個分頁（設備｜誰能存取｜場域設定）與「維護」區在 StructurePage / SiteTabs（REVIEW P1-7）。
import { useTranslation } from 'react-i18next';
import { useScope } from '../../lib/scope';
import { hasOrgPerm, orgUsable } from '../../lib/planeApi';
import { OrgGate, relevantOrgs } from '../shell/OrgGate';
import { StructurePage } from './StructurePage';

export function SitesPage() {
  const { t } = useTranslation();
  const { orgs, homes } = useScope();
  const usable = relevantOrgs(orgs, homes).filter(orgUsable);
  // 先放管得了全樹的 team 組織，再放個人組織，最後其他（可能是節點管理員）
  const rank = (o: (typeof usable)[number]) => (hasOrgPerm(o, 'org.sites') ? (o.kind === 'team' ? 0 : 1) : 2);
  const sorted = [...usable].sort((a, b) => rank(a) - rank(b));
  return (
    <div className="page">
      <h1 className="page-title">{t('nav.sites')}</h1>
      <OrgGate candidates={sorted} empty={<p className="card muted">{t('ot.no_structure_access')}</p>}>
        {(current) => <StructurePage key={current.org_id} org={current} />}
      </OrgGate>
    </div>
  );
}
